// extracted by mini-css-extract-plugin
export default {"dialog":"gi58l","scroll-lock":"mX_sa"};